import { render } from "./ViewDbaPixKey.vue?vue&type=template&id=07450edd"
import script from "./ViewDbaPixKey.vue?vue&type=script&lang=js"
export * from "./ViewDbaPixKey.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__